import { Skeleton, Box, Flex, Heading, Button } from '@chakra-ui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { FiArrowLeft } from 'react-icons/fi';

export const CreditAgreementsViewTemplate = ({
  children,
  disableSelectors,
}: {
  children: React.ReactNode;
  disableSelectors: boolean;
}) => {
  const history = useHistory();

  const { data: userData } = useGetUserQuery();

  if (!userData || !userData.user) {
    return <Skeleton data-testid="loading-reports-view" height="600px" />;
  }

  const { organizationId } = userData.user;

  return (
    <Box>
      <Flex justify="space-between" width="100%">
        <Heading marginBottom="70px" display="inline-block">
          Credit Agreement Configuration
        </Heading>
        <Box>
          <CreditFacilitySelect
            organizationId={organizationId}
            isDisabled={disableSelectors}
          />
          {disableSelectors && (
            <Flex justify="flex-end" alignItems="center" mt="10px" mb="10px">
              <Button
                onClick={() => history.goBack()}
                marginLeft={3}
                rightIcon={<FiArrowLeft />}
                aria-label="back"
              >
                Back
              </Button>
            </Flex>
          )}
        </Box>
      </Flex>
      {children}
    </Box>
  );
};
